<template>

  <div class="container-fluid" >

    <div class="card">
      <div class="card-body">

          <div class="title">SQAaaS module selection</div>

          <div class="modules">

            <div class="module paas" @click="gotoPaaS()">
              <img class="module-img" src="../../static/paas.png" alt="Pipeline as a Service">
              <div class="module-title">Pipeline as a Service</div>
              <div class="short description">Compose customized CI/CD pipelines for your code repositories.</div>
              <div class="long description">The Pipeline as a Service module offers developers with a graphical means to compose workflows, aka CI/CD pipelines, that carry out the software verification and validation (V&V) processes in an automated fashion.</div>
            </div>

            <div class="module qaa" @click="gotoQAA()">
              <img class="module-img" src="../../static/qaa.png" alt="Quality assessment and awarding">
              <div class="module-title">Quality Assessment & Awarding</div>
              <div class="short description">Take credit of the achievements in terms of software and service quality.</div>
              <div class="long description">The Quality Assessment & Awarding (QAA) module analyzes the level of compliance of a given code repository with a set of standards for software.</div>
            </div>

          </div>

      </div>
    </div>

  </div>

</template>

<script>

  export default {
    methods:{
      gotoPaaS(){ this.$router.push('/pipeline-as-a-service'); },
      gotoQAA() { this.$router.push('/full-assessment'); }
  }
}

</script>

<style scoped>


  .card{
    margin: 2em 1.5em;
    background-color: #FAFAFA;

    .card-body{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 2em;

      .title{
        font-size: 3em;
        font-weight: bold;
        color: #76BAC6;
        text-align: center;
      }

      .modules{
        display: flex;
        justify-content: center;
        padding: 1.5em;
        gap: 60px;
      }

      .module{
        width: min(40%, 500px);
        padding: 40px;
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
        box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
        transition: background-color 1s;

        &.paas{
          border: 2px solid #F1A190;
          background: linear-gradient(#F1A19030, #B5716230);
        }
        &.paas:hover{
          background-color: #F1A19070;
          img { transform: scale(1.05); }
        }
        &.qaa{
          border: 2px solid #90C7F1;
          background: linear-gradient(#90C7F130, #4484b530);
        }
        &.qaa:hover{
          background-color: #90C7F170;
          img { transform: scale(1.05); }
        }

        .module-img{
          height: 260px;
          transition: transform 0.5s;
        }

        .module-title{
          font-size: 20px;
          font-weight: 700;
          margin: 1em 0;
        }

        .description { font-size: 16px;}
        .short.description { display: none; }
      }
    }
  }


  @media (max-width: 800px) {
    .card{
      .card-body{
        .title{
          font-size: 2.3em;
        }
        .modules{
          padding: 1.5em 0;
          gap: 15px;
        }
        .module{
          width: 50%;
          padding: 20px 3%;
          img { height: 150px; }
          .long.description { display: none; }
          .short.description { display: block; }
        }
      }
    }
  }

</style>
